import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const CheckmarkIcon = registerClientReference(
    function() { throw new Error("Attempted to call CheckmarkIcon() from the server but CheckmarkIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "CheckmarkIcon",
);
export const ErrorIcon = registerClientReference(
    function() { throw new Error("Attempted to call ErrorIcon() from the server but ErrorIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "ErrorIcon",
);
export const LoaderIcon = registerClientReference(
    function() { throw new Error("Attempted to call LoaderIcon() from the server but LoaderIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "LoaderIcon",
);
export const ToastBar = registerClientReference(
    function() { throw new Error("Attempted to call ToastBar() from the server but ToastBar is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "ToastBar",
);
export const ToastIcon = registerClientReference(
    function() { throw new Error("Attempted to call ToastIcon() from the server but ToastIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "ToastIcon",
);
export const Toaster = registerClientReference(
    function() { throw new Error("Attempted to call Toaster() from the server but Toaster is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "Toaster",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/node_modules/react-hot-toast/dist/index.mjs from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "default",
);
export const resolveValue = registerClientReference(
    function() { throw new Error("Attempted to call resolveValue() from the server but resolveValue is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "resolveValue",
);
export const toast = registerClientReference(
    function() { throw new Error("Attempted to call toast() from the server but toast is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "toast",
);
export const useToaster = registerClientReference(
    function() { throw new Error("Attempted to call useToaster() from the server but useToaster is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "useToaster",
);
export const useToasterStore = registerClientReference(
    function() { throw new Error("Attempted to call useToasterStore() from the server but useToasterStore is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-hot-toast/dist/index.mjs",
    "useToasterStore",
);
